(function () {
  class ContactForm {
    constructor(formEl) {
      this.form = formEl;
      this.container = formEl.closest('[data-contact-form]') || formEl.parentElement;
      this.errorBox = this.container.querySelector('[data-validation-error]');
      this.privacyCheckbox = this.form.querySelector('[data-privacy-checkbox]');
      this.submitBtn = this.form.querySelector('[data-submit-btn]');
      this.bind();
      this.syncSubmitState();
    }

    bind() {
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.form.querySelectorAll('[data-required="true"]').forEach((el) => {
        el.addEventListener('input', () => {
          if (el.value && el.value.trim() !== '') {
            el.classList.remove('is-invalid');
          }
        });
        el.addEventListener('change', () => {
          if (el.value && el.value.trim() !== '') {
            el.classList.remove('is-invalid');
          }
        });
      });
      if (this.privacyCheckbox) {
        this.privacyCheckbox.addEventListener('change', () => this.syncSubmitState());
        const wrapper = this.privacyCheckbox.closest('.contact-privacy');
        if (wrapper) {
          wrapper.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', (e) => e.stopPropagation());
          });
        }
      }
    }

    syncSubmitState() {
      if (!this.submitBtn) return;
      if (this.privacyCheckbox) {
        this.submitBtn.disabled = !this.privacyCheckbox.checked;
      } else {
        this.submitBtn.disabled = false;
      }
    }

    onSubmit(e) {
      const requiredFields = this.form.querySelectorAll('[data-required="true"]');
      let firstError = null;
      requiredFields.forEach((input) => {
        if (!input.value || input.value.trim() === '') {
          input.classList.add('is-invalid');
          if (!firstError) firstError = input;
        } else {
          input.classList.remove('is-invalid');
        }
      });

      if (firstError) {
        e.preventDefault();
        this.showError();
        firstError.focus();
        return;
      }

      this.hideError();
    }

    showError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = false;
      this.errorBox.setAttribute('role', 'alert');
    }

    hideError() {
      if (!this.errorBox) return;
      this.errorBox.hidden = true;
    }
  }

  function init() {
    document.querySelectorAll('form.contact-form-section').forEach((f) => {
      if (!f.dataset.contactFormInit) {
        f.dataset.contactFormInit = '1';
        new ContactForm(f);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
